import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://bulut12.com";
const DEFAULT_IMAGE = SITE + "/apple-touch-icon.png";

/**
 * Sayfa-başı SEO meta bileşeni.
 * Kullanım:
 *   <Seo
 *     title="e-Fatura Programı | Bulut12"
 *     description="..."
 *     path="/efatura"
 *     keywords="e-fatura, ..."
 *   />
 */
const Seo = ({ title, description, path, keywords, image, noindex }) => {
  const canonical = path ? SITE + path : SITE + "/";
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Bulut12" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="tr_TR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Seo;
